import script from "./LearningByCallSign.vue?vue&type=script&setup=true&lang=js"
export * from "./LearningByCallSign.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__